import { LOGIN_USER, LOGOUT_USER, USER_ERROR } from "../Actions";

let initialState = {
	isLogged: false,
	loggedUser: null,
	loading: false,
	error: null,
};

export default function userReducer(state = initialState, action) {
	switch (action.type) {
		default:
			return state;
		case LOGIN_USER:
			return {
				...state,
				loggedUser: action.payload,
				loading: false,
				isLogged: true,
			};
		case USER_ERROR:
			return { ...state, error: action.payload, loading: false };
		case LOGOUT_USER:
			return {
				...state,
				loggedUser: action.payload,
				loading: false,
				isLogged: false,
			};
	}
}
